import { Link } from 'react-router-dom';
import { ArrowRight, CalendarDays, Clock } from 'lucide-react';
import { posts } from '../../data/blog';

// "Latest from the blog" strip for the home page. Shows the 3 most recent posts.
export const BlogStrip = () => {
  const latest = [...posts]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 3);

  if (latest.length === 0) return null;

  return (
    <section className="py-20 cream-bg border-t border-[#E2DAC5]" data-testid="home-blog-strip">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 reveal">
          <div>
            <p className="section-label mb-3">Insights &amp; Advice</p>
            <h2
              className="text-3xl md:text-4xl lg:text-5xl font-extrabold leading-[1.05] text-[#0A2E18]"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Lawn &amp; garden tips from the crew.
            </h2>
          </div>
          <Link
            to="/blog"
            onClick={() => window.scrollTo(0, 0)}
            data-testid="home-blog-view-all"
            className="shrink-0 inline-flex items-center gap-1.5 text-[#1B6E37] font-bold text-sm hover:gap-2.5 transition-all"
          >
            View all articles <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((p) => (
            <article
              key={p.slug}
              className="group bg-white rounded-xl overflow-hidden border border-[#E2DAC5] shadow-sm hover:shadow-lg transition-shadow flex flex-col"
              data-testid={`home-blog-card-${p.slug}`}
            >
              <Link
                to={`/blog/${p.slug}`}
                onClick={() => window.scrollTo(0, 0)}
                className="block relative h-52 overflow-hidden"
              >
                <img
                  src={p.cover}
                  alt={p.coverAlt}
                  loading="lazy"
                  width="400"
                  height="208"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-[#D98A00] text-[#0A2E18] text-[11px] font-extrabold uppercase tracking-wide">
                  {p.category}
                </span>
              </Link>
              <div className="p-6 flex flex-col flex-1">
                <div className="flex items-center gap-4 text-xs text-[#3D463C] mb-3">
                  <span className="flex items-center gap-1.5"><CalendarDays className="w-3.5 h-3.5" /> {p.dateDisplay}</span>
                  <span className="flex items-center gap-1.5"><Clock className="w-3.5 h-3.5" /> {p.readTime}</span>
                </div>
                <h3
                  className="text-xl font-extrabold text-[#0A2E18] leading-snug mb-2"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  <Link to={`/blog/${p.slug}`} onClick={() => window.scrollTo(0, 0)} className="hover:text-[#1B6E37] transition-colors">
                    {p.title}
                  </Link>
                </h3>
                <p className="text-[#212B20] text-sm leading-relaxed flex-1 line-clamp-3">{p.excerpt}</p>
                <Link
                  to={`/blog/${p.slug}`}
                  onClick={() => window.scrollTo(0, 0)}
                  data-testid={`home-blog-read-more-${p.slug}`}
                  className="inline-flex items-center gap-1.5 mt-5 text-[#1B6E37] font-bold text-sm hover:gap-2.5 transition-all"
                >
                  Read article <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
